<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
  >
    <ItpButton
      :text="'Get printer attributes...'|pgettext('Button')"
      :spinning="actions.getAttributes && actions.getAttributes.isRunning"
      @click.prevent="evh_8564662037462133_clickPrevent($event, {})"
    >
    </ItpButton>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    :label="'Print file'|pgettext('PrinterConfig')"
    :helpTooltip="'Select a file to send to the network printer for testing purposes.'|pgettext('PrinterConfig')"
  >
    <b-form-file
      v-model="selectedFile"
      :placeholder="'Choose a file or drop it here'|pgettext('PrinterConfig')"
      :drop-placeholder="'Drop file here'|pgettext('PrinterConfig')"
      lang="hu"
      accept="pdf"
      class="col mb-3"
    >
    </b-form-file>
    <ItpButton
      :disabled="!selectedFile"
      :text="'Print'|gettext"
      icon="fa-printer"
      :spinning="actions.printFileAction && actions.printFileAction.isRunning"
      class="col-auto"
      @click="evh_4186377094414664_click($event, {})"
    >
    </ItpButton>
  </ItpFormGroup>
  <table
    class="table table-condensed table-sm"
    v-if="jobs && jobs.length"
  >
    <thead>
      <tr>
        <th>
        </th>
        <th>
          {{ 'ID'|pgettext('PrinterTester|ColHead') }}
        </th>
        <th>
          {{ 'State'|pgettext('PrinterTester|ColHead') }}
        </th>
        <th>
          {{ 'State reasons'|pgettext('PrinterTester|ColHead') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        :key="item.id"
        v-for="item in jobs"
      >
        <td>
          <ItpButton
            :text="'Reload'|gettext"
            icon="fa-refresh"
            :spinning="item.busy"
            @click="evh_4747808328624104_click($event, {item})"
          >
          </ItpButton>
        </td>
        <td>
          <strong>{{ item.id }}</strong>
        </td>
        <td>
          {{ item.state }}
        </td>
        <td>
          {{ item.state_reasons }}
        </td>
      </tr>
    </tbody>
  </table>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class PrinterTester extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  reloadJobAction(...args: any[]) {
    const [job] = args;

    job.busy = true;

    return this.$fn
      .fetch('print_job', { parameters: { printer: this.printerId, id: job.id } })
      .then(data => {
        console.log(data)
        _.extend(job, data);
        job.busy = false;
      })
  }

  @Prop({
    required: true,
    type: String,
  })
  printerId!: string;

  @Watch('printerId')
  onPrinter_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("printerId")
  }

  selectedFile!: any;
  jobs!: any;
  ux!: any;
  dataMembers = ['selectedFile', 'jobs', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedFile: null,
        jobs: null,
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_showModal_5016_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8564662037462133_showModal_5016, alias=undefined
    return {
      name: "DataViewerModal",
      props: {
        mode: "yaml",
        content: $event.data.response.data,
      }
      ,
    }
  }

  async act_8564662037462133_request_5014_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8564662037462133_request_5014, alias=getAttributes
    return {
      operation: "printer_attributes",
      data: {
        printer: this.printerId,
      }
      ,
    }
  }

  async evh_8564662037462133_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_setData_5020_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_4186377094414664_setData_5020, alias=undefined
    return {
      path: "jobs",
      value: $event.data.response.data.jobs,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_4186377094414664_request_5018_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4186377094414664_request_5018, alias=printFile
    return {
      method: "POST",
      operation: "print_document",
      data: {
        printer: this.printerId,
        document: this.selectedFile,
      }
      ,
      contentType: "multipart/form-data",
    }
  }

  async evh_4186377094414664_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_click.executeFromDOM(this, event, scope);
  }

  async act_4747808328624104_script_5022_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4747808328624104_script_5022, alias=undefined
    this.reloadJobAction($event.scope.item)
  }

  async act_4747808328624104_script_5022_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4747808328624104_script_5022, alias=undefined
    return {
      value: () => this.act_4747808328624104_script_5022_getActionArgs_value($event),
    }
  }

  async evh_4747808328624104_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4747808328624104_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_5012: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_5011: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8564662037462133_showModal_5016: actions.ShowModalAction;
    evh_8564662037462133_success_5015: actions.EventHandlerImpl;
    act_8564662037462133_request_5014: actions.RequestAction;
    evh_8564662037462133_clickPrevent_5013: actions.EventHandlerImpl;
    evh_8564662037462133_clickPrevent: actions.EventHandlerGroup;
    act_4186377094414664_setData_5020: actions.SetDataAction;
    evh_4186377094414664_success_5019: actions.EventHandlerImpl;
    act_4186377094414664_request_5018: actions.RequestAction;
    evh_4186377094414664_click_5017: actions.EventHandlerImpl;
    evh_4186377094414664_click: actions.EventHandlerGroup;
    act_4747808328624104_script_5022: actions.ScriptAction;
    evh_4747808328624104_click_5021: actions.EventHandlerImpl;
    evh_4747808328624104_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_5012 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_5011 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_5012,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_5011],
      }
    );
    const act_8564662037462133_showModal_5016 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8564662037462133_showModal_5016_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_success_5015 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_showModal_5016,
        event: "success",
        displayName: "showModal",
      }
    );
    const act_8564662037462133_request_5014 = new actions.RequestAction(
      {
        actionArgs: this.act_8564662037462133_request_5014_getActionArgs,
        displayName: "getAttributes",
        events: [evh_8564662037462133_success_5015],
      }
    );
    const evh_8564662037462133_clickPrevent_5013 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_request_5014,
        event: "click.prevent",
        displayName: "getAttributes",
      }
    );
    const evh_8564662037462133_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_clickPrevent_5013],
      }
    );
    const act_4186377094414664_setData_5020 = new actions.SetDataAction(
      {
        actionArgs: this.act_4186377094414664_setData_5020_getActionArgs,
        events: [],
      }
    );
    const evh_4186377094414664_success_5019 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_setData_5020,
        event: "success",
        displayName: "setData",
      }
    );
    const act_4186377094414664_request_5018 = new actions.RequestAction(
      {
        actionArgs: this.act_4186377094414664_request_5018_getActionArgs,
        displayName: "printFile",
        events: [evh_4186377094414664_success_5019],
      }
    );
    const evh_4186377094414664_click_5017 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_request_5018,
        event: "click",
        displayName: "printFile",
      }
    );
    const evh_4186377094414664_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_click_5017],
      }
    );
    const act_4747808328624104_script_5022 = new actions.ScriptAction(
      {
        actionArgs: this.act_4747808328624104_script_5022_getActionArgs,
        events: [],
      }
    );
    const evh_4747808328624104_click_5021 = new actions.EventHandlerImpl(
      {
        action: act_4747808328624104_script_5022,
        event: "click",
        displayName: "script",
      }
    );
    const evh_4747808328624104_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4747808328624104_click_5021],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_5012,
      evh_7315092382398562_reload_5011,
      evh_7315092382398562_reload,
      act_8564662037462133_showModal_5016,
      evh_8564662037462133_success_5015,
      act_8564662037462133_request_5014,
      evh_8564662037462133_clickPrevent_5013,
      evh_8564662037462133_clickPrevent,
      act_4186377094414664_setData_5020,
      evh_4186377094414664_success_5019,
      act_4186377094414664_request_5018,
      evh_4186377094414664_click_5017,
      evh_4186377094414664_click,
      act_4747808328624104_script_5022,
      evh_4747808328624104_click_5021,
      evh_4747808328624104_click,
      getAttributes: act_8564662037462133_request_5014,
      printFile: act_4186377094414664_request_5018,
    }
  }
}

Vue.component("PrinterTester", PrinterTester);

</script>